<template>
  <div>
    <!-- <b-field
      grouped
      group-multiline>
      <div
        v-for="(column, index) in columnsTemplate"
        :key="index"
        class="control">
        <b-checkbox v-model="column.visible">
          {{ column.title }}
        </b-checkbox>
      </div>
    </b-field> -->
    <div class="double-table">
      <div class=" live">
        <h2>Momenteel live</h2>
        <b-table
          :data="liveHeadersDateFixed">
          <template slot-scope="props">
            <b-table-column
              sortable
              centered
              field="Title"
              label="Title">
              {{ props.row.title }}
            </b-table-column>
            <b-table-column
              sortable
              centered
              :custom-sort="sortByStartDate"
              field="startdate"
              label="Start date">
              {{ props.row.startDate.toLocaleDateString() }}
            </b-table-column>
            <b-table-column
              sortable
              centered
              :custom-sort="sortByEndDate"
              field="enddate"
              label="End date">
              {{ props.row.endDate.toLocaleDateString() }}
            </b-table-column>
            <b-table-column
              field="image"
              label="Afbeelding"
              centered>
              <img
                class="table-image"
                :src="props.row.imageUrl"
                alt="">
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="staging">
        <h2>Live na publiceren</h2>
        <b-table
          :data="headersDateFixed">
          <template slot-scope="props">
            <b-table-column
              sortable
              centered
              field="Title"
              label="Title">
              {{ props.row.title }}
            </b-table-column>
            <b-table-column
              sortable
              centered
              :custom-sort="sortByStartDate"
              field="startdate"
              label="Start date">
              {{ props.row.startDate.toLocaleDateString() }}
            </b-table-column>
            <b-table-column
              sortable
              centered
              :custom-sort="sortByEndDate"
              field="enddate"
              label="End date">
              {{ props.row.endDate.toLocaleDateString() }}
            </b-table-column>
            <b-table-column
              field="image"
              label="Afbeelding"
              centered>
              <img
                class="table-image"
                :src="props.row.imageUrl"
                alt="">
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>

    <b-button
      v-if="!publishing"
      @click="publishLive">
      Publiceer
    </b-button>
    <b-button
      v-else-if="publishing === true"
      type="is-error"
      loading>
      Publishing
    </b-button>
    <b-button
      v-else-if="publishing === 'failed'"
      type="is-error">
      Mislukt
    </b-button>
    <b-button
      v-else
      class="succes"
      type="is-success">
      Gepubliceerd
    </b-button>
  </div>
</template>

<script>
import axios from "axios";
import { db, firebase } from "../../firebase";
import apiUrl from "../../js/url";

export default {
  name: "PublishHeaders",
  data() {
    return {
      publishing: false,
      headers: [],
      liveHeaders: [],
      columnsTemplate: [
        { title: "ID", field: "title", visible: true },
        { title: "Link", field: "url", visible: false },
        { title: "Startdate", field: "startDate", visible: false },
        { title: "EndDate", field: "endDate", visible: false },
        { title: "Knoptekst", field: "buttonText", visible: false },
        { title: "Knopkleur", field: "buttonColor", visible: false }
      ]
    };
  },
  computed: {
    headersDateFixed() {
      return this.headers.map(header => {
        return Object.assign({}, header, {
          startDate: header.startDate.toDate(),
          endDate: header.endDate.toDate()
        });
      });
    },
    liveHeadersDateFixed() {
      return this.liveHeaders.map(header => {
        return Object.assign({}, header, {
          startDate: new Date(header.startDate),
          endDate: new Date(header.endDate)
        });
      });
    }
  },
  beforeCreate() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        this.$router.push("/login");
      }
    });
  },
  created() {
    const url = apiUrl();
    axios
      .get(`${url}/api/live/`)
      .then(response => {
        this.liveHeaders = response.data;
      })
      .catch(error => {
        console.log(error, "failed publishing");
      });
  },
  methods: {
    publishLive() {
      this.publishing = true;
      const url = apiUrl();
      axios
        .post(
          `${url}/publish/publish-staging.php`,
          JSON.stringify(this.headersDateFixed)
        )
        .then(() => {
          this.publishing = "completed";
        })
        .catch(error => {
          console.log("failed published staging", error);
          this.publishing = "failed";
        });
    },
    sortByStartDate(a, b, isAsc) {
      if (isAsc) {
        return new Date(b.startDate) - new Date(a.startDate);
      }
      return new Date(a.startDate) - new Date(b.startDate);
    },
    sortByEndDate(a, b, isAsc) {
      if (isAsc) {
        return new Date(b.endDate) - new Date(a.endDate);
      }
      return new Date(a.endDate) - new Date(b.endDate);
    }
  },
  firestore: {
    headers: db.collection("headers")
  }
};
</script>

<style lang="scss" scoped>
.table-image {
  width: 70px;
}
.double-table {
  display: flex;
  overflow-x: scroll;
  justify-content: space-between;
  max-width: 1400px;
  margin-bottom: 3rem;

  .live {
    flex-grow: 1;
    margin-right: 5rem;
  }

  .staging {
    flex-grow: 1;
  }
}
.succes {
  pointer-events: none;
}
</style>